<template>
    <div :class="['tab-content', className]">
        <div
            v-for="(item, index) in tabs"
            :key="index"
            :class="['tab-content-item', index === activeIndex ? 'active' : '']"
            @click="handleClick(item)"
        >
            <span>{{ item.title }}</span>
        </div>
        <slot />
    </div>
</template>
<script>
export default {
    props: {
        className: {
            type: String,
            default: ''
        },
        tabs: {
            type: Array,
            default: () => []
        },
        query: {
            type: Object,
            default: () => {}
        }
    },
    watch: {
        '$route.path': {
            immediate: true,
            handler() {
                this.activeIndex = this.tabs.findIndex(item => this.$route.name == item.name);
            }
        }
    },
    data() {
        return {
            activeIndex: null
        };
    },
    mounted() {
        this.activeIndex = this.tabs.findIndex(item => this.$route.name == item.name);
    },
    methods: {
        handleClick(item) {
            this.$router.push({name: item.name, query: this.$route.query});
        }
    }
};
</script>

<style lang="scss">
.tab-content {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .tab-content-item {
        background: #f7f8fa;
        border-radius: 13px;
        font-weight: bold;
        font-size: 16px;
        color: #9a9a9d;
        line-height: 40px;
        padding: 0 24px;
        text-align: center;
        margin: 0 5px;
        cursor: pointer;
    }
}
</style>
